import DescriptionIcon from "@mui/icons-material/Description";
import { IBrochureType } from "../exports/interfaces";
import useMobile from "../hooks/useMobile";

const Brochure = (props: { brochure: IBrochureType[] }) => {
  const mobile = useMobile();
  return (
    <>
      <a
        // href={`${process.env.REACT_APP_strapiUrl}${props.brochure[0]?.attributes?.Brochure?.data?.attributes?.url}`}
        href={`https://online.fliphtml5.com/zbcst/iqil/#p=1`}
        download="BB&C Brochure"
        target="_blank"
        rel="noreferrer"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "5px",
          textDecoration: "none",
          color: "#384A62",
        }}
      >
        <DescriptionIcon />
        {!mobile && props?.brochure[0]?.attributes?.Title}
      </a>
    </>
  );
};

export default Brochure;


// *** PDF Flipbook ***

// import React, { useState, forwardRef } from "react";
// import { Dialog, DialogContent, IconButton } from "@mui/material";
// import DescriptionIcon from "@mui/icons-material/Description";
// import CloseIcon from "@mui/icons-material/Close";
// import HTMLFlipBook from "react-pageflip";
// import { IBrochureType } from "../exports/interfaces";
// import useMobile from "../hooks/useMobile";
// import { Document, Page, pdfjs } from "react-pdf";
// import fileUrl from "../assets/BEST.pdf";

// Setup PDF.js worker
// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

// interface PageProps {
//   number: number;
//   children?: React.ReactNode;
// }

// Page wrapper for Flipbook
// const FlipPage = forwardRef<HTMLDivElement, PageProps>(
//   ({ number, children }, ref) => {
//     return (
//       <div
//         ref={ref}
//         className="demoPage"
//         style={{
//           backgroundColor: "#fff",
//           padding: "10px",
//           textAlign: "center",
//           border: "1px solid #ddd",
//         }}
//       >
//         {children}
//         <p style={{ marginTop: "10px", fontSize: "12px" }}>Page {number}</p>
//       </div>
//     );
//   }
// );
// FlipPage.displayName = "FlipPage";

// Main Component
// const Brochure = ({ brochure }: { brochure: IBrochureType[] }) => {
//   const mobile = useMobile();
//   const [open, setOpen] = useState(false);
//   const [numPages, setNumPages] = useState<number>(0);

//   const handleClickOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);

//   // const fileUrl = `${process.env.REACT_APP_strapiUrl}${brochure[0]?.attributes?.Brochure?.data?.attributes?.url}`;
//   // console.log(brochure[0]?.attributes?.Brochure?.data?.attributes?.url);

//   return (
//     <>
//       {/* Clickable Brochure Link */}
//       <span
//         onClick={handleClickOpen}
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: "5px",
//           textDecoration: "none",
//           color: "#384A62",
//           cursor: "pointer",
//         }}
//       >
//         <DescriptionIcon />
//         {!mobile && brochure[0]?.attributes?.Title}
//       </span>

//       {/* Dialog */}
//       <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             padding: "10px 20px",
//           }}
//         >
//           <h3 style={{ margin: 0 }}>
//             {brochure[0]?.attributes?.Title || "Brochure"}
//           </h3>
//           <IconButton onClick={handleClose}>
//             <CloseIcon />
//           </IconButton>
//         </div>

//         <DialogContent>
//           {/* PDF Flipbook */}
//           {brochure[0]?.attributes?.Brochure?.data?.attributes?.url && (
//             <Document
//               file={fileUrl}
//               onLoadSuccess={({ numPages }) => setNumPages(numPages)}
//             >
//               <HTMLFlipBook
//                 width={300}
//                 height={420}
//                 size="stretch"
//                 minWidth={250}
//                 maxWidth={600}
//                 minHeight={350}
//                 maxHeight={700}
//                 showCover={true}
//                 mobileScrollSupport={true}
//                 drawShadow={true}
//                 flippingTime={700}
//                 usePortrait={true}
//                 className="mx-auto"
//                 {...({} as any)}
//               >
//                 {Array.from(new Array(numPages), (_, index) => (
//                   <FlipPage key={index} number={index + 1}>
//                     <Page
//                       pageNumber={index + 1}
//                       renderAnnotationLayer={false}
//                       renderTextLayer={false}
//                       width={380}
//                     />
//                   </FlipPage>
//                 ))}
//               </HTMLFlipBook>
//             </Document>
//           )}
//         </DialogContent>
//       </Dialog>
//     </>
//   );
// };

// export default Brochure;
